export const ZELPYE_LOGO_VARIANT = {
  LOGO: "logo",
  LOGO_OUTLINE: "logoOutline",
  TEXT: "text",
  TEXT_LOGO: "textLogo",
  WHITE_TEXT_LOGO: "whiteTextLogo",
} as const;

export type ZelpyeLogoVariant =
  (typeof ZELPYE_LOGO_VARIANT)[keyof typeof ZELPYE_LOGO_VARIANT];

export const ZELPYE_LOGO_ALT: Record<ZelpyeLogoVariant, string> = {
  [ZELPYE_LOGO_VARIANT.LOGO]: "Zelpye logo",
  [ZELPYE_LOGO_VARIANT.LOGO_OUTLINE]: "Zelpye logo outline",
  [ZELPYE_LOGO_VARIANT.TEXT]: "Zelpye",
  [ZELPYE_LOGO_VARIANT.TEXT_LOGO]: "Zelpye text logo",
  [ZELPYE_LOGO_VARIANT.WHITE_TEXT_LOGO]: "Zelpye white text logo",
};

export const ZELPYE_LOGO_BASE_CLASS = "zelpye-logo";

export const ZELPYE_LOGO_VARIANT_CLASS: Record<ZelpyeLogoVariant, string> = {
  [ZELPYE_LOGO_VARIANT.LOGO]: "zelpye-logo--logo",
  [ZELPYE_LOGO_VARIANT.LOGO_OUTLINE]: "zelpye-logo--logo-outline",
  [ZELPYE_LOGO_VARIANT.TEXT]: "zelpye-logo--text",
  [ZELPYE_LOGO_VARIANT.TEXT_LOGO]: "zelpye-logo--text-logo",
  [ZELPYE_LOGO_VARIANT.WHITE_TEXT_LOGO]: "zelpye-logo--white-text-logo",
};
